import React, { useEffect, useState } from "react";
import { Col, Container, Row, Stack, Nav, Tab, Tabs, Button } from "react-bootstrap";
import TODIS_FORM_ROADS from "./form/GENERAL/general";
import TODIS_FORM_ROADS_DESC from "./form/GENERAL/rdescription";
import TODIS_FORM_ROADS_STATUS from "./form/LP/lstatus";
import TODIS_FORM_ROADS_ELEGPROJECT from "./form/GENERAL/relegibilityproject";
import TODIS_FORM_ROADS_TENCOMPLIANCE from "./form/GENERAL/rtencompliance";
import TODIS_FORM_ROADS_PERFOMANCE_INDICADOR from "./form/GENERAL/rperfomanceindicador";
import TODIS_FORM_ROADS_INDICATORS from "./form/GENERAL/rindicators";
import TODIS_FORM_ROADS_IMPNM from "./form/GENERAL/rimpnm";
import { TODIS_FORM_FIELD, TODIS_FORM_DSC } from "../../components/Forms";
import "react-datepicker/dist/react-datepicker.css";
import { BsExclamationCircleFill } from "react-icons/bs";

const TODIS_FORM = ({errors, touched, status}) => {

    return (
        <Tabs defaultActiveKey="General" id="uncontrolled-tab-example" className="mb-3 todis-form-tabs-wrapper p-1 mt-3">
            
            <Tab eventKey="General" title="General">
                <Container>
                    <Row>
                        <TODIS_FORM_ROADS errors={errors} touched={touched} disabled={status} TypeForm="internatRouteId" TetCategory="tenTCategory"/>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="targetTentSec" label="Targeted TEN-T section(s) (current network layout)" name="targetTentSec" disabled={status}/>
                                {errors.targetTentSec && touched.targetTentSec ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20}/></span>Error: {errors.targetTentSec}</div>) : null}
                        </Col>
                        <Col lg={6}>
                                <TODIS_FORM_FIELD id="newTentSec" label="New TEN-T section(s) (after project's implementation)" name="newTentSec" disabled={status}/>
                                {errors.newTentSec && touched.newTentSec ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20}/></span>Error: {errors.newTentSec}</div>) : null}
                        </Col>
                        {/* <Col lg={6}>
                                <TODIS_FORM_FIELD_YES_NO id="immedPartTentNet" label="Tolling interoperability" name="immedPartTentNet"  disabled={status}/>
                                {errors.immedPartTentNet && touched.immedPartTentNet ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20}/></span>Error: {errors.immedPartTentNet}</div>) : null}
                        </Col> */}
                        <Col lg={12}>
                                <TODIS_FORM_DSC id="remarks" label="Remarks" name="remarks" disabled={status}/>
                                {errors.remarks && touched.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20}/></span>Error: {errors.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
                
            </Tab>
            <Tab eventKey="Description" title="Description ">
                <Container>
                    <Row>
                         <TODIS_FORM_ROADS_DESC errors={errors} touched={touched} disabled={status} TypeForm="roadsImpPmDescDTO"/>
                         <Col lg={12}>
                                <TODIS_FORM_DSC id="roadsImpPmDescDTO.remarks" label="Remarks" name="roadsImpPmDescDTO.remarks" disabled={status}/>
                                {errors.roadsImpPmDescDTO && errors.roadsImpPmDescDTO.remarks && touched.roadsImpPmDescDTO && touched.roadsImpPmDescDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20}/></span>Error: {errors.roadsImpPmDescDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="Status" title="Status">
                <TODIS_FORM_ROADS_STATUS errors={errors} touched={touched} disabled={status} TypeForm="roadsImpPmStatusDTO"/>
            </Tab>
            <Tab eventKey="iElegibilityProject" title="Targeted TEN-T indicators">
                <Container>
                    <Row>
                         <TODIS_FORM_ROADS_ELEGPROJECT errors={errors} touched={touched} disabled={status} TypeForm="roadsImpPmEligiTentDTO"/>
                         <Col lg={12}>
                                <TODIS_FORM_DSC id="roadsImpPmEligiTentDTO.remarks" label="Remarks" name="roadsImpPmEligiTentDTO.remarks" disabled={status}/>
                                {errors.roadsImpPmEligiTentDTO && errors.roadsImpPmEligiTentDTO.remarks && touched.roadsImpPmEligiTentDTO && touched.roadsImpPmEligiTentDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20}/></span>Error: {errors.roadsImpPmEligiTentDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
                
            </Tab>
            <Tab eventKey="TenCompliance" title="TEN-T compliance of the related road section">
                 <Container>
                    <Row>
                        <TODIS_FORM_ROADS_TENCOMPLIANCE errors={errors} touched={touched} disabled={status} TypeForm="roadsImpPmTentcompDTO"/>
                        <Col lg={12}>
                                <TODIS_FORM_DSC id="roadsImpPmTentcompDTO.remarks" label="Remarks" name="roadsImpPmTentcompDTO.remarks" disabled={status}/>
                                {errors.roadsImpPmTentcompDTO && errors.roadsImpPmTentcompDTO.remarks && touched.roadsImpPmTentcompDTO && touched.roadsImpPmTentcompDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20}/></span>Error: {errors.roadsImpPmTentcompDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>                                
            </Tab>
            {/* <Tab eventKey="PerfomanceIndicador" title="Performance Indicators">
                <Container>
                    <Row>
                        <TODIS_FORM_ROADS_PERFOMANCE_INDICADOR errors={errors} touched={touched} disabled={status} TypeForm="roadsImpPmPiDTO"/>
                        <Col lg={12}>
                                <TODIS_FORM_DSC id="roadsImpPmPiDTO.remarks" label="Remarks" name="roadsImpPmPiDTO.remarks" disabled={status}/>
                                {errors.roadsImpPmPiDTO && errors.roadsImpPmPiDTO.remarks && touched.roadsImpPmPiDTO && touched.roadsImpPmPiDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20}/></span>Error: {errors.roadsImpPmPiDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>   
               
            </Tab> */}
            <Tab eventKey="Indicators" title="Performance Indicators">
                <Container>
                    <Row>
                        <TODIS_FORM_ROADS_INDICATORS errors={errors} touched={touched} disabled={status} TypeForm="roadsImpPmIndicatorsDTO"/>
                        <Col lg={12}>
                                <TODIS_FORM_DSC id="roadsImpPmIndicatorsDTO.remarks" label="Remarks" name="roadsImpPmIndicatorsDTO.remarks" disabled={status}/>
                                {errors.roadsImpPmIndicatorsDTO && errors.roadsImpPmIndicatorsDTO.remarks && touched.roadsImpPmIndicatorsDTO && touched.roadsImpPmIndicatorsDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20}/></span>Error: {errors.roadsImpPmIndicatorsDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>                                 
            </Tab>       
            <Tab eventKey="Mpnm" title="MP">
                <Container>
                    <Row>
                        <TODIS_FORM_ROADS_IMPNM errors={errors} touched={touched} disabled={status} TypeForm="roadsImpNmDTO"/>
                        <Col lg={12}>
                                <TODIS_FORM_DSC id="roadsImpNmDTO.remarks" label="Remarks" name="roadsImpNmDTO.remarks" disabled={status}/>
                                {errors.roadsImpNmDTO && errors.roadsImpNmDTO.remarks && touched.roadsImpNmDTO &&  touched.roadsImpNmDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20}/></span>Error: {errors.roadsImpNmDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>                                 
            </Tab>                           
        </Tabs>
    )
}

export default TODIS_FORM;